import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "35",
  height: "35"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M29.168 13.855H17.5a3.646 3.646 0 0 0-3.645 3.645v11.668a3.646 3.646 0 0 0 3.645 3.645h11.668a3.646 3.646 0 0 0 3.645-3.645V17.5a3.646 3.646 0 0 0-3.645-3.645m2.187 15.313c0 1.207-.98 2.187-2.187 2.187H17.5a2.19 2.19 0 0 1-2.187-2.187V17.5c0-1.207.98-2.187 2.187-2.187h11.668c1.207 0 2.187.98 2.187 2.187ZM5.832 15.313a3.646 3.646 0 0 1-3.644-3.645V5.832a3.646 3.646 0 0 1 3.644-3.644h5.836a3.646 3.646 0 0 1 3.645 3.644h-1.458c0-1.207-.98-2.187-2.187-2.187H5.832c-1.207 0-2.187.98-2.187 2.187v5.836c0 1.207.98 2.187 2.187 2.187ZM20.418 9.48h-8.75c-1.211 0-2.188.977-2.188 2.188v8.75c0 1.207.977 2.187 2.188 2.187v1.457a3.647 3.647 0 0 1-3.648-3.644v-8.75a3.65 3.65 0 0 1 3.648-3.648h8.75a3.647 3.647 0 0 1 3.645 3.648h-1.458c0-1.211-.98-2.188-2.187-2.188m0 0",
  style: {"stroke":"none","fill-rule":"nonzero","fill":"#000","fill-opacity":"1"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }